import { useRoles } from '@/hooks/queries/use-roles.query';
import { APP_USER_ROLES } from '@/types';
import { ResourceAccess } from '@/user/resource-access/resource-access.type';
import { useUserResourceAccess } from '@/user/resource-access/use-user-resource-access';

export const useRolesOptions = () => {
  const { hasAccessToResource } = useUserResourceAccess();
  const { data: appRoles } = useRoles();

  const rolesOptions = appRoles
    ? appRoles
        .filter(role => {
          if (
            role.name === APP_USER_ROLES.ADMIN &&
            !hasAccessToResource(ResourceAccess.USER_RESOURCES_INVITE_ADMIN)
          )
            return false;
          else if (
            role.name === APP_USER_ROLES.MANAGER &&
            !hasAccessToResource(ResourceAccess.USER_RESOURCES_INVITE_MANAGER)
          )
            return false;
          return true;
        })
        .map(role => ({
          label: role.name,
          value: role.id,
        }))
    : [];

  return rolesOptions;
};
